import { type MCPServerInfo } from '../../types';

const KubernetesServer: MCPServerInfo = {
  serverId: 'KUBERNETES',
  slug: 'kubernetes',
  name: 'Kubernetes',
  description:
    'Manage your Kubernetes clusters and workloads using Kubernetes MCP Server',
  authenticationType: 'STATIC_CREDS',
  source: {
    sourceType: 'LOCAL_PACKAGE',
    transport: 'STDIO',
    commandFunction: `(config) => {
      const baseArgs = ['-y', 'kubernetes-mcp-server@latest']
      
      // Note: toolsets value must be comma-separated
      const enabledToolsets = [
        '--toolsets', 
        'config,core,helm,kcp,kiali,kubevirt'
      ]

      const optionalFlags = [];
      if (config.readOnly && config.readOnly.toLowerCase() === 'true') {
        optionalFlags.push('--read-only');
      }
      if (config.kubeconfig) {
        optionalFlags.push('--kubeconfig', config.kubeconfig);
      }

      return {
        command: 'npx',
        args: [...baseArgs, ...enabledToolsets, ...optionalFlags],
        env: {}
      }
    }`
  },
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {
      readOnly: {
        type: 'string',
        description: 'Run in read-only mode (true/false)',
        sensitive: false,
        default: 'false'
      },
      kubeconfig: {
        type: 'string',
        description: 'Absolute path to kubeconfig file (optional)',
        sensitive: false
      }
    }
  },
  instructions: {
    installSetupInstructions: `## Requirements

    1. Ensure \`npm\` is installed on your system.
    2. Ensure your Kubernetes configuration is available at:
      - Default location: \`~/.kube/config\`
      - **OR** specify a custom **absolute** path to your kubeconfig file`
  },
  deprecated: true
};

export default KubernetesServer;
